import type { ReactNode } from "react"
import { NotifierContext, type NotifierFunction } from "./notifier-context"

interface Props {
  notifier: NotifierFunction
  children: ReactNode
}

/**
 * Makes a {@link NotifierFunction} available to descendants via
 * {@link import("./notifier-context").useNotifier}. In the frontend the react-render modifier
 * supplies one that pipes to the Ember Notifier service.
 */
export function NotifierProvider({ notifier, children }: Props) {
  return <NotifierContext.Provider value={notifier}>{children}</NotifierContext.Provider>
}
